import { Location } from 'react-router-dom';
import { APP_MODULES, IUserAccessParams, USER_ROLES } from '../shared/services/auth/auth.service';

export const isModuleAccess = (userAccessParams: IUserAccessParams, location: Location<any>) => {
  const module = transformPathToModule(location);
  return checkModuleAccess(userAccessParams, module);
};

const transformPathToModule = (location: Location<any>): APP_MODULES => {
  if (location.pathname.startsWith('/customer')) {
    return APP_MODULES.CUSTOMER;
  } else if (location.pathname.startsWith('/article')) {
    return APP_MODULES.ARTICLE;
  } else if (location.pathname.startsWith('/order')) {
    return APP_MODULES.ORDER;
  } else if (location.pathname.startsWith('/offer')) {
    return APP_MODULES.OFFER;
  } else if (location.pathname.startsWith('/production')) {
    return APP_MODULES.PRODUCTION;
  } else if (location.pathname.startsWith('/invoice')) {
    return APP_MODULES.INVOICE;
  } else if (location.pathname.startsWith('/debitor')) {
    return APP_MODULES.DEBITOR;
  } else if (location.pathname.startsWith('/settings')) {
    return APP_MODULES.OPTIONS;
  } else if (location.pathname.startsWith('/globalSearch')) {
    return APP_MODULES.GLOBAL_SEARCH;
  } else if (location.pathname.startsWith('/statistic')) {
    return APP_MODULES.STATISTIC;
  }
  return APP_MODULES.CUSTOMER;
};

export const checkModuleAccess = (
  userAccessParams: IUserAccessParams,
  module: APP_MODULES,
): boolean => {
  if (
    userAccessParams.role === USER_ROLES.NOT_DEFINED ||
    userAccessParams.role === USER_ROLES.ADMIN
  ) {
    return true;
  }
  // when role === USER_ROLES.CUSTOM_ACCESS
  return userAccessParams.modules[module];
};
